import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form-group" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "d-flex align-items-center mt-1" };
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.label)
            ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true),
        (_ctx.saving)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 1 }))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 2,
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.localValue.values[_ctx.selectedLanguage]) = $event)),
                onInput: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.save && _ctx.save(...args))),
                ref: "inputto"
            }, null, 544)), [
                [_vModelText, _ctx.localValue.values[_ctx.selectedLanguage]]
            ]),
        _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("b", { class: "mr-1" }, "Traduzioni:", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang, i) => {
                return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-small btn-link mr-1", { active: _ctx.selectedLanguage == lang }]),
                    key: i,
                    onClick: ($event) => (_ctx.selectedLanguage = lang)
                }, _toDisplayString(lang), 11, _hoisted_4));
            }), 128))
        ])
    ]));
}
